import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';
var composeEnhancers = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
var enhancer = composeEnhancers(applyMiddleware(thunk));
export function getStore(preloadedState) {
    return createStore(rootReducer, preloadedState, enhancer);
}
export default getStore();
